export const gender = [
  { label: '男', value: 'M' },
  { label: '女', value: 'F' }
];

export const trueFalse = [
  { label: '否', value: false },
  { label: '是', value: true }
];

export const isE_Bill = [
  { label: '電子', value: true },
  { label: '紙本', value: false },
];

export const advisory = [
  { label: '保單問題', value: 'CPQ' },
  { label: '保單變更', value: 'CPC' },
  { label: '契約終止', value: 'CPS' },
  { label: '理賠相關', value: 'CPO' },
  { label: '其他', value: 'CPA' }
];

export const isNative = [
  { label: '本國籍', value: true },
  { label: '外國籍', value: false }
];
//20201111 Wen modify 因應新冠肺炎 停止國外旅遊
/*export const abroad = [
  { label: '國外', value: true },
  { label: '國內', value: false }
];*/
export const abroad = [
  { label: '國內', value: false } 
];

export const CarBody = [
  { label: '強制/任意險', value: false },
  { label: '加購丙式', value: true },
];

export const PremiumSources = [
  { label: '薪資', value: '1' },
  { label: '投資收入', value: '2' },
  { label: '存款(退休金)', value: '3' },
  { label: '存款(其他)', value: '4' },
  { label: '父母/二等親代繳', value: '5' },
  { label: '貸款', value: '6' },
  { label: '保單借款', value: '7' },
  { label: '定存解約', value: '8' },
  { label: '保險解約金', value: '9' }//,
  //{ label: '其他', value: '10' }  //20210530Wen Modify
];

export const pettype = [
  { label: '犬', value: 'DOG' },
  { label: '貓', value: 'CAT' }
];

export const petgenders = [
  { label: '公', value: 'M' },
  { label: '母', value: 'F' }
];
